import { DataSet, PeekdataApi } from 'peekdata-datagateway-api-sdk';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { dataapi } from 'src/constants/dataapi';

const borderColors = dataapi.colors;

const peekdataApi = new PeekdataApi({
  baseUrl: dataapi.apiUrl,
  timeout: 60000,
});

const request = dataapi.request;

export class ChartJsLine extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      dimensions: null,
      metrics: null,
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    peekdataApi.data.getDataOptimized(request)
      .then(response => {
        const dataSet = new DataSet(response);
        const dimensions = dataSet.getDimensionsValues();
        const metrics = dataSet.getMetricsValues();

        this.setState({ isLoading: false, dimensions, metrics });
      })
      .catch(error => {
        this.setState({ isLoading: false, error: error.toString() });
      });
  }

  render() {
    const { isLoading, error, dimensions, metrics } = this.state;

    if (error) {
      return error;
    }

    if (isLoading || !dimensions || dimensions.length < 1 || !metrics || metrics.length < 1) {
      return null;
    }

    const data = {
      labels: dimensions.map(d => d.join(', ')),
      datasets: metrics.map((m, index) => ({
        label: m.metric.title,
        data: m.values.map(d => d.value),
        borderColor: borderColors[index],
      })),
    };

    return (
      <Line height={225} data={data} />
    );
  }
}
